import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
// import Button from '@material-ui/core/Button';
// import ShowIcon from '@material-ui/icons/Visibility';
// import HideIcon from '@material-ui/icons/VisibilityOff';
import Switch from '@material-ui/core/Switch';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  },
  root: {
    width: 50,
    padding: 0
  },
  switchBase: {
    padding: 1,
    height: 24,
    width: 50,
    justifyContent: 'left',
    '&$checked': {
      transform: 'translateX(0px)',
      justifyContent: 'right',
      color: '#ffffff',
      '& + $track': {
        backgroundColor: '#2196F3',
        opacity: 1,
        border: 'none'
      }
    },
    '&$focusVisible $thumb': {
      color: '#2196F3',
      border: '6px solid #fff'
    }
  },
  thumb: {
    width: 22,
    height: 22
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid #E0E0E0`,
    backgroundColor: '#E0E0E0',
    opacity: 1,
    transition: 'all 0.5s',
    height: 24,
    width: 50
  },
  checked: {},
  focusVisible: {}
};

const enhance = compose(pure);

// const button = enhance(({ classes, params, onClickAction, showHide }) => {
//   let showHideButton;
//   let showHideText;
//   if (showHide) {
//     showHideButton = <ShowIcon className={classes.leftIcon} />;
//     showHideText = `表示`;
//   } else {
//     showHideButton = <HideIcon className={classes.leftIcon} />;
//     showHideText = `非表示`;
//   }
//   return (
//     <Button
//       onClick={() => {
//         onClickAction(params);
//       }}
//     >
//       {showHideButton}
//       {showHideText}
//     </Button>
//   );
// });
const IOSSwitch = enhance(
  ({ classes, params, onClickAction, showHide, disabled }) => {
    return (
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked
        }}
        onChange={() => {
          onClickAction(params);
        }}
        checked={showHide === 1}
        disabled={disabled}
      />
    );
  }
);

export default withStyles(styles)(IOSSwitch);
